module.exports = __webpack_public_path__ + "static/media/cat-5.73fd9338.jpg";